import React from "react";
import { Navigate } from "react-router-dom";
import { SYSTEM_DEFAULTS } from "../util/constants";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem(SYSTEM_DEFAULTS.ACCESS_TOKEN);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
